import React from 'react';
import cn from 'classnames';
import { withRouter } from 'react-router';
import AddToWatchlistButton from '../AddToWatchlistButton/AddToWatchlistButton';
import QuickSearch from '../QuickSearch/QuickSearch';
import SummitMessage from '../SummitMessage/SummitMessage';
import BuyButton from '../BuyButton/BuyButton';
import MMRMessageContent from '../MMRMessageContent/MMRMessageContent';

import { useWatchlistDispatch } from '../../Hooks/useWatchlist';
import { setDefaultFund } from '../WithCompareState/WithCompareState';
import GqlQueryWrapper from '../GqlQueryWrapper/GqlQueryWrapper';
import TablePreRender from '../Table/Table.prerender';
import ResourceLink from '../ResourceLink/ResourceLink';

import {
    displayShortDate,
    formatWithCommasOrNA,
    displayCurrencyOrNA
} from '../../utils/Format/Format';
import {
    getAssetValue,
    generalizeFund,
    isBuyRestricted
} from '../../utils/fund-info';
import {
    ETF_TITLE_QUERY,
    FUND_TITLE_QUERY
} from '../../graphql/queries/fund-title.query';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import WithUserState from '../WithUserState/WithUserState';
import ErrorMessageNoData from '../ErrorMessages/ErrorMessageNoData';
import { UH_FUNDS, CARD_NAMES } from '../../utils/constants';
import urlCheck from '../../utils/urlCheck';
import selectFundsRibbon from '../../images/sf-certified-16.svg';

import styles from './FundSnapshot.css';
import MethodologyModal from '../SelectFundsMethodology/MethodologyModal/MethodologyModal';

class FundSnapshot extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openQS: false,
            openCriteriaModal: false
        };
        global.tehhistory = props.history;
    }

    toggleModal = () => {
        const { openQS } = this.state;
        this.setState({ openQS: !openQS });
    };

    openModal = () => {
        this.setState({ openQS: true });
    };

    closeModal = () => {
        this.setState({ openQS: false });
    };

    openCriteriaModal = () => {
        this.setState({ openCriteriaModal: true });
    };

    closeCriteriaModal = () => {
        this.setState({ openCriteriaModal: false });
    };

    handleChange = (event) => {
        const { history } = this.props;
        history.push(`/${event.target.value}${window.location.search}`);
    };

    compareFund = () => {
        const { ticker, history } = this.props;
        setDefaultFund(ticker);
        history.push(`/compare`);
    };

    render() {
        const { ticker, etf } = this.props;
        const viewingFromApp = urlCheck('mobile');
        const prospectusLink = {
            name: 'View Prospectus',
            link:
                'https://prospectus-express.broadridge.com/summary.asp?doctype=pros&clientid=trowepll&fundid=',
            replaceCusip: true,
            replaceTrpCode: false
        };
        return (
            <React.Fragment>
                <div
                    className={cn('section-wrapper', {
                        mobile: viewingFromApp
                    })}
                >
                    <div className="section-container">
                        <GqlQueryWrapper
                            query={etf ? ETF_TITLE_QUERY : FUND_TITLE_QUERY}
                            variables={{ ticker }}
                            dataFunc={generalizeFund}
                            placeholder={() => <TablePreRender height="15px" />}
                        >
                            {({ data }) => {
                                if (!data) {
                                    return (
                                        <ErrorMessageNoData
                                            cardName={CARD_NAMES.FUND_SNAPSHOT}
                                        />
                                    );
                                }

                                const funds = [data.fund];

                                const {
                                    fund: {
                                        shortName: name,
                                        exchange,
                                        previousName,
                                        correspondingFundTicker,
                                        iClass,
                                        cusip,
                                        openToNewInvestors,
                                        openToSubsequentInvestments,
                                        trpCode,
                                        activeMoneyMarketFundMessages,
                                        price,
                                        selectFund,
                                        name: etfFundName
                                    }
                                } = data;

                                // deconstruct price here so that null data doesn't cause page crash
                                const {
                                    price: nav = '',
                                    closingPrice = '',
                                    asOfDate = '',
                                    outstandingShares = ''
                                } =
                                    price || {};

                                const buyRestricted =
                                    !etf &&
                                    isBuyRestricted(
                                        openToNewInvestors,
                                        openToSubsequentInvestments
                                    );
                                return (
                                    <React.Fragment>
                                        <div>
                                            <MMRMessageContent
                                                activeFundMessages={
                                                    activeMoneyMarketFundMessages
                                                }
                                            />
                                            <div className="breadcrumb-and-phone-number">
                                                {!viewingFromApp && (
                                                    <Breadcrumb
                                                        showScreenLink
                                                        name={name}
                                                        etfName={etfFundName}
                                                    />
                                                )}
                                                <div className="ph-num">
                                                    {!viewingFromApp && (
                                                        <a href="tel:1-866-223-4889">
                                                            Call a financial
                                                            consultant at
                                                            866-223-4889
                                                        </a>
                                                    )}
                                                </div>
                                            </div>
                                            <div>
                                                <div
                                                    className={
                                                        etf
                                                            ? 'title-col'
                                                            : 'mf-title-col'
                                                    }
                                                >
                                                    <div className="trp-name fund-title">
                                                        T. Rowe Price
                                                        {selectFund && (
                                                            <span className="methodology-note">
                                                                <span className="divider hide-in-mobile">
                                                                    {' '}
                                                                    |{' '}
                                                                </span>

                                                                <img
                                                                    src={
                                                                        selectFundsRibbon
                                                                    }
                                                                    alt="Select Funds Certified"
                                                                    className="select-funds-ribbon"
                                                                />
                                                                <button
                                                                    className="criteria-modal-link"
                                                                    onClick={() =>
                                                                        this.openCriteriaModal()
                                                                    }
                                                                    onKeyPress={() =>
                                                                        this.openCriteriaModal()
                                                                    }
                                                                    type="button"
                                                                >
                                                                    T. Rowe
                                                                    Price®
                                                                    Select Fund
                                                                </button>
                                                            </span>
                                                        )}
                                                    </div>
                                                    <h1 className="fund fund-title">
                                                        {name} ({ticker})
                                                        {UH_FUNDS.includes(
                                                            trpCode
                                                        ) && <sup>**</sup>}
                                                    </h1>
                                                    <span>
                                                        {!etf && (
                                                            <span>
                                                                <span className="asset-class">
                                                                    Share
                                                                    Class:&nbsp;{
                                                                        iClass
                                                                    }
                                                                    {iClass && (
                                                                        <select
                                                                            className="select-snapshot isIclass"
                                                                            onChange={
                                                                                this
                                                                                    .handleChange
                                                                            }
                                                                            defaultValue={
                                                                                ticker
                                                                            }
                                                                        >
                                                                            {correspondingFundTicker && (
                                                                                <option
                                                                                    value={
                                                                                        correspondingFundTicker
                                                                                    }
                                                                                >
                                                                                    Investor
                                                                                </option>
                                                                            )}
                                                                            <option
                                                                                value={
                                                                                    ticker
                                                                                }
                                                                            >
                                                                                I
                                                                                Class
                                                                            </option>
                                                                        </select>
                                                                    )}
                                                                    {!iClass && (
                                                                        <select
                                                                            className="select-snapshot"
                                                                            onChange={
                                                                                this
                                                                                    .handleChange
                                                                            }
                                                                        >
                                                                            <option
                                                                                value={
                                                                                    ticker
                                                                                }
                                                                            >
                                                                                Investor
                                                                            </option>
                                                                            {correspondingFundTicker && (
                                                                                <option
                                                                                    value={
                                                                                        correspondingFundTicker
                                                                                    }
                                                                                >
                                                                                    I
                                                                                    Class
                                                                                </option>
                                                                            )}
                                                                        </select>
                                                                    )}
                                                                </span>
                                                            </span>
                                                        )}
                                                    </span>
                                                    {!viewingFromApp && (
                                                        <dl
                                                            className={`snapshot-data ${etf ||
                                                                'mf-snapshot-pad'}`}
                                                        >
                                                            <div
                                                                className={`${
                                                                    etf
                                                                        ? 'snapshot-top-row'
                                                                        : 'mf-snapshot-row'
                                                                }`}
                                                            >
                                                                <div
                                                                    className={
                                                                        etf
                                                                            ? 'term-wrapper'
                                                                            : 'mf-term-wrapper'
                                                                    }
                                                                >
                                                                    <dt>
                                                                        Ticker
                                                                    </dt>
                                                                    <dd>
                                                                        <React.Fragment
                                                                        >
                                                                            <span className="fund-title-ticker">
                                                                                <button
                                                                                    id="open-fund-select"
                                                                                    onClick={
                                                                                        this
                                                                                            .openModal
                                                                                    }
                                                                                    type="button"
                                                                                >
                                                                                    {
                                                                                        ticker
                                                                                    }{' '}
                                                                                    <span
                                                                                    >
                                                                                        &#9660;
                                                                                    </span>
                                                                                </button>
                                                                            </span>
                                                                            <QuickSearch
                                                                                closeModal={
                                                                                    this
                                                                                        .closeModal
                                                                                }
                                                                                toggle={
                                                                                    this
                                                                                        .toggleModal
                                                                                }
                                                                                open={
                                                                                    this
                                                                                        .state
                                                                                        .openQS
                                                                                }
                                                                            />
                                                                        </React.Fragment>
                                                                    </dd>
                                                                </div>
                                                                {etf && (
                                                                    <div className="term-wrapper etf-exchange">
                                                                        <dt>
                                                                            Exchange
                                                                        </dt>
                                                                        <dd>
                                                                            {
                                                                                exchange
                                                                            }
                                                                        </dd>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div
                                                                className={`${
                                                                    etf
                                                                        ? 'snapshot-bottom-row'
                                                                        : 'mf-snapshot-row'
                                                                }`}
                                                            >
                                                                <div
                                                                    className={
                                                                        etf
                                                                            ? 'term-wrapper'
                                                                            : 'mf-term-wrapper mf-nav'
                                                                    }
                                                                >
                                                                    <dt>
                                                                        NAV*
                                                                    </dt>
                                                                    <dd>
                                                                        {getAssetValue(
                                                                            nav
                                                                        )}
                                                                    </dd>
                                                                </div>
                                                                {etf && (
                                                                    <div className="term-wrapper etf-shares">
                                                                        <dt>
                                                                            Shares
                                                                            Outstanding*
                                                                        </dt>
                                                                        <dd>
                                                                            {formatWithCommasOrNA(
                                                                                outstandingShares
                                                                            )}
                                                                        </dd>
                                                                    </div>
                                                                )}
                                                                {etf && (
                                                                    <div className="term-wrapper">
                                                                        <dt>
                                                                            Market
                                                                            Price*
                                                                        </dt>
                                                                        <dd>
                                                                            {displayCurrencyOrNA(
                                                                                closingPrice
                                                                            )}
                                                                        </dd>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <dt
                                                                className={`hide-in-desktop ${
                                                                    etf
                                                                        ? 'term-wrapper-etf-date'
                                                                        : 'term-wrapper-mf-date'
                                                                }`}
                                                            >
                                                                *As of{' '}
                                                                {displayShortDate(
                                                                    asOfDate
                                                                )}
                                                            </dt>
                                                        </dl>
                                                    )}

                                                    {!viewingFromApp && (
                                                        <dt
                                                            className={`hide-in-mobile ${
                                                                etf
                                                                    ? 'term-wrapper-etf-date'
                                                                    : 'term-wrapper-mf-date'
                                                            }`}
                                                        >
                                                            *As of{' '}
                                                            {displayShortDate(
                                                                asOfDate
                                                            )}
                                                        </dt>
                                                    )}

                                                    {previousName && (
                                                        <div className="former-name">
                                                            <div>
                                                                Formerly the T.
                                                                Rowe Price{' '}
                                                                {previousName}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div>
                                                <div
                                                    className={`${
                                                        etf
                                                            ? 'button-col-wrapper'
                                                            : 'mf-button-col button-col-wrapper'
                                                    } move-right`}
                                                >
                                                    <div>
                                                        {/* Disable buy button for closed funds - ref: DE9337 */}
                                                        {!urlCheck(
                                                            'mobile'
                                                        ) && (
                                                            <WithUserState>
                                                                {({
                                                                    loggedIn,
                                                                    userStateLoaded
                                                                }) => (
                                                                    <React.Fragment
                                                                    >
                                                                        <div
                                                                            className={`
                                                                                ${
                                                                                    etf ||
                                                                                    buyRestricted
                                                                                        ? 'two-button-col'
                                                                                        : 'button-col'
                                                                                }
                                                                            `}
                                                                        >
                                                                            <BuyButton
                                                                                content="Buy Now"
                                                                                funds={
                                                                                    funds
                                                                                }
                                                                                ticker={
                                                                                    ticker
                                                                                }
                                                                                fundName={
                                                                                    name
                                                                                }
                                                                                open={
                                                                                    etf
                                                                                        ? true
                                                                                        : openToNewInvestors
                                                                                }
                                                                                buyRestricted={
                                                                                    buyRestricted
                                                                                }
                                                                                loggedIn={
                                                                                    loggedIn
                                                                                }
                                                                                userStateLoaded={
                                                                                    userStateLoaded
                                                                                }
                                                                                blue
                                                                                loud
                                                                                etf={
                                                                                    etf
                                                                                }
                                                                            />
                                                                        </div>
                                                                        {!etf &&
                                                                            !buyRestricted && (
                                                                                <React.Fragment
                                                                                >
                                                                                    <div className="button-col add-to-watchlist">
                                                                                        <AddToWatchlistButton
                                                                                            funds={[
                                                                                                ticker
                                                                                            ]}
                                                                                            loggedIn={
                                                                                                loggedIn
                                                                                            }
                                                                                            loud
                                                                                            dispatch={
                                                                                                useWatchlistDispatch
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                    <div className="button-col compare-btn">
                                                                                        <button
                                                                                            onClick={
                                                                                                this
                                                                                                    .compareFund
                                                                                            }
                                                                                            id={`compare-${ticker}`}
                                                                                            className="btn secondary-btn"
                                                                                            type="button"
                                                                                        >
                                                                                            Compare
                                                                                        </button>
                                                                                    </div>
                                                                                </React.Fragment>
                                                                            )}
                                                                    </React.Fragment>
                                                                )}
                                                            </WithUserState>
                                                        )}
                                                        <div className="button-col prospectus-link">
                                                            <ResourceLink
                                                                key={
                                                                    prospectusLink
                                                                }
                                                                id={`view-prospectus-${ticker}`}
                                                                cusip={cusip}
                                                                extraClass="snapshot-prospectus-link"
                                                                link={
                                                                    prospectusLink
                                                                }
                                                                trpCode={
                                                                    trpCode
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* summit start */}
                                        {!buyRestricted && (
                                            <SummitMessage
                                                iClass={iClass}
                                                ticker={ticker}
                                                etf={etf}
                                                openToNewInvestors={
                                                    openToNewInvestors
                                                }
                                            />
                                        )}
                                        {/* summit end */}
                                    </React.Fragment>
                                );
                            }}
                        </GqlQueryWrapper>
                    </div>
                </div>
                <style jsx>{styles}</style>
                {this.state.openCriteriaModal && (
                    <MethodologyModal open onClose={this.closeCriteriaModal} />
                )}
            </React.Fragment>
        );
    }
}

export default withRouter(FundSnapshot);
